const te = {
    "gui.menuBar.file": "ఫైల్",
    "gui.menuBar.edit": "సవరించు",
    "gui.menuBar.new": "కొత్తది",
    "gui.menuBar.saveNow": "ఇప్పుడు భద్రపరచు",
    "gui.menuBar.saveAsCopy": "నకలుగా భద్రపరచు",
    "gui.menuBar.remix": "రీమిక్స్",
    "gui.menuBar.languageSelector": "భాష ఎంచుకోండి",
    "gui.menuBar.tutorialsLibrary": "ట్యూటోరియల్స్",
    "gui.menuBar.community": "సమాజం",
    "gui.menuBar.wiki": "ఏజెంట్‌ని డౌన్‌లోడ్ చేయండి",
    "gui.menuBar.restoreSprite": "స్ప్రైట్‌ను పునరుద్ధరించు",
    "gui.menuBar.restoreSound": "ధ్వనిని పునరుద్ధరించు",
    "gui.menuBar.restoreCostume": "దుస్తులను పునరుద్ధరించు",
    "gui.menuBar.restore": "పునరుద్ధరించు",
    "gui.menuBar.turboModeOff": "టర్బో మోడ్ ఆపివేయి",
    "gui.menuBar.turboModeOn": "టర్బో మోడ్ ఆన్ చేయి",
    "gui.menuBar.noDeviceSelected": "పరికరం ఎంచుకోబడలేదు",
    "gui.menuBar.noConnection": "కనెక్షన్ లేదు",
    "gui.menuBar.downloadToComputer": "కంప్యూటర్‌కు డౌన్‌లోడ్ చేయి",
    "gui.menuBar.checkUpdate": "అప్‌డేట్‌ను తనిఖీ చేయి",
    "gui.menuBar.installDriver": "డ్రైవర్ ఇన్‌స్టాల్ చేయి",
    "gui.menuBar.clearCacheAndRestart":
        "క్యాష్‌ను క్లియర్ చేసి మళ్లీ ప్రారంభించు",
    "gui.adblockModal.title": "యాడ్ బ్లాకర్ గుర్తించబడింది",
    "gui.adblockModal.body":
        "TIFStudio యాడ్ బ్లాకర్ వల్ల బ్లాక్ అవుతోంది. దయచేసి TIFStudio కోసం యాడ్ బ్లాకర్‌ను ఆఫ్ చేయండి.",
    "gui.adblockModal.reload": "మళ్లీ లోడ్ చేయి",
    "gui.alerts.createsuccess": "కొత్త ప్రాజెక్ట్ సృష్టించబడింది.",
    "gui.alerts.createcopysuccess": "ప్రాజెక్ట్ నకలుగా భద్రపరచబడింది.",
    "gui.alerts.createremixsuccess": "ప్రాజెక్ట్ రీమిక్స్‌గా భద్రపరచబడింది.",
    "gui.alerts.creating": "కొత్తది సృష్టిస్తోంది...",
    "gui.alerts.creatingCopy": "ప్రాజెక్ట్ నకలు సృష్టిస్తోంది...",
    "gui.alerts.creatingRemix": "ప్రాజెక్ట్ రీమిక్స్ సృష్టిస్తోంది...",
    "gui.alerts.downloading": "డౌన్‌లోడ్ అవుతోంది...",
    "gui.alerts.loading": "లోడ్ అవుతోంది...",
    "gui.alerts.saving": "భద్రపరుస్తోంది...",
    "gui.alerts.savesuccess": "ప్రాజెక్ట్ భద్రపరచబడింది.",
    "gui.alerts.savingError": "ప్రాజెక్ట్‌ను భద్రపరచలేకపోయింది.",
    "gui.alerts.cloudInfo":
        "గమనిక: క్లౌడ్ వేరియబుల్స్ సంఖ్యలను మాత్రమే సపోర్ట్ చేస్తాయి, అక్షరాలు లేదా చిహ్నాలు కాదు.",
    "gui.alerts.cloudVariableFull": "క్లౌడ్ వేరియబుల్ పరిమితి నిండిపోయింది.",
    "gui.alerts.importedSvgTitle": "అప్‌లోడ్ చేసిన SVG ఫైల్‌లో సమస్య",
    "gui.alerts.importedSvgMessage":
        "SVG ఫైల్‌ను లోడ్ చేయలేకపోయింది. ఇది సరైన SVG ఫైలా?",
    "gui.alerts.importedSvgReset": "మళ్లీ ప్రయత్నించు",
    "gui.alerts.importedSvgCancel": "రద్దు చేయి",
    "gui.alerts.uploadError": "అప్‌లోడ్ లోపం",
    "gui.alerts.uploadSuccess": "అప్‌లోడ్ విజయవంతం",
    "gui.gui.addExtension": "ఎక్స్‌టెన్షన్ జోడించు",
    "gui.gui.code": "కోడ్",
    "gui.gui.backdrops": "నేపథ్యాలు",
    "gui.gui.costumes": "దుస్తులు",
    "gui.gui.sounds": "ధ్వనులు",
    "gui.gui.codeTab": "కోడ్",
    "gui.gui.costumesTab": "దుస్తులు",
    "gui.gui.backdropsTab": "నేపథ్యాలు",
    "gui.gui.soundsTab": "ధ్వనులు",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "కెమెరాను ఆపివేయి",
    "gui.menu-bar.realtimeMode": "స్క్రాచ్",
    "gui.menu-bar.programMode": "ప్రోగ్రామ",
    "gui.hardwareConsole.send": "పంపు",
    "gui.hardwareConsole.buadrate": "బాడ్ రేటు",
    "gui.hardwareConsole.endOfLine": "లైన్ ముగింపు",
    "gui.hardwareConsole.hexform": "హెక్స్ ఫార్మాట్",
    "gui.hardwareConsole.autoScroll": "ఆటో స్క్రోల్",
    "gui.hardwareHeader.upload": "అప్‌లోడ్ చేయి",
    "gui.stageHeader.codeStageSizeLarge": "పెద్ద స్టేజ్",
    "gui.stageHeader.codeStageSizeSmall": "చిన్న స్టేజ్",
    "gui.stageHeader.hideStage": "స్టేజ్‌ను దాచు",
    "gui.stageHeader.fullscreenControl": "పూర్తి స్క్రీన్ నియంత్రణ",
    "gui.extensionLibrary.comingSoon": "త్వరలో వస్తోంది",
    "gui.extensionLibrary.requires": "అవసరం",
    "gui.extensionLibrary.collaboration": "సహకారం",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "తయారీదారు",
    "gui.extensionLibrary.version": "వెర్షన్",
    "gui.extensionLibrary.author": "రచయిత",
    "gui.extensionLibrary.programMode": "ప్రోగ్రామ్ మోడ్",
    "gui.extensionLibrary.programLanguage": "ప్రోగ్రామ్ భాష",
    "gui.extensionLibrary.deviceLearnMore": "మరిన్ని తెలుసుకోండి",
    "gui.extensionLibrary.extensionHelp": "సహాయం",
    "gui.extensionLibrary.Processing": "ప్రాసెసింగ్...",
    "gui.extensionLibrary.loaded": "లోడ్ చేయబడింది",
    "gui.extensionLibrary.notLoaded": "లోడ్ కాలేదు",
    "gui.extensionLibrary.chooseAnExtension": "ఎక్స్‌టెన్షన్ ఎంచుకోండి",
    "gui.library.filterPlaceholder": "వెతుకు",
    "gui.library.allTag": "అన్నీ",
    "gui.loader.message1": "స్ప్రైట్‌లను సృష్టిస్తోంది...",
    "gui.loader.message2": "ధ్వనులను లోడ్ చేస్తోంది...",
    "gui.loader.message3": "దుస్తులను లోడ్ చేస్తోంది...",
    "gui.loader.message4": "ఎక్స్‌టెన్షన్‌లను లోడ్ చేస్తోంది...",
    "gui.loader.message5": "బ్లాక్‌లను సృష్టిస్తోంది...",
    "gui.loader.message6": "గణితం చేస్తోంది...",
    "gui.loader.message7": "లోడ్ అవుతోంది...",
    "gui.loader.message8": "సిద్ధం చేస్తోంది...",
    "gui.loader.headline": "ప్రాజెక్ట్ లోడ్ అవుతోంది",
    "gui.loader.creating": "ప్రాజెక్ట్ సృష్టిస్తోంది",
    "gui.spriteLibrary.chooseASprite": "స్ప్రైట్ ఎంచుకోండి",
    "gui.spriteLibrary.paintASprite": "గీయండి",
    "gui.spriteLibrary.uploadASprite": "స్ప్రైట్ అప్‌లోడ్ చేయి",
    "gui.spriteLibrary.surprise": "ఆశ్చర్యం",
    "gui.soundLibrary.chooseASound": "ధ్వని ఎంచుకోండి",
    "gui.soundLibrary.record": "రికార్డ్ చేయి",
    "gui.soundLibrary.uploadASound": "ధ్వని అప్‌లోడ్ చేయి",
    "gui.costumeLibrary.chooseACostume": "దుస్తు ఎంచుకోండి",
    "gui.costumeLibrary.paintACostume": "గీయండి",
    "gui.costumeLibrary.uploadACostume": "దుస్తు అప్‌లోడ్ చేయి",
    "gui.backdropLibrary.chooseABackdrop": "నేపథ్యం ఎంచుకోండి",
    "gui.backdropLibrary.paintABackdrop": "గీయండి",
    "gui.backdropLibrary.uploadABackdrop": "నేపథ్యం అప్‌లోడ్ చేయి",
    "gui.spriteSelector.addSpriteFromLibrary": "స్ప్రైట్ ఎంచుకోండి",
    "gui.spriteSelector.addSpriteFromPaint": "గీయండి",
    "gui.spriteSelector.addSpriteFromSurprise": "ఆశ్చర్యం",
    "gui.spriteSelector.addSpriteFromFileUpload": "స్ప్రైట్ అప్‌లోడ్ చేయి",
    "gui.stageSelector.addBackdropFromLibrary": "నేపథ్యం ఎంచుకోండి",
    "gui.stageSelector.addBackdropFromPaint": "గీయండి",
    "gui.stageSelector.addBackdropFromSurprise": "ఆశ్చర్యం",
    "gui.stageSelector.addBackdropFromFileUpload": "నేపథ్యం అప్‌లోడ్ చేయి",
    "gui.stageSelector.stage": "స్టేజ్",
    "gui.stageSelector.backdrops": "నేపథ్యాలు",
    "gui.spriteSelectorItem.contextMenuDuplicate": "నకలు తయారు చేయి",
    "gui.spriteSelectorItem.contextMenuExport": "ఎక్స్‌పోర్ట్ చేయి",
    "gui.spriteSelectorItem.contextMenuDelete": "తొలగించు",
    "gui.spriteInfo.sprite": "స్ప్రైట్",
    "gui.spriteInfo.size": "పరిమాణం",
    "gui.spriteInfo.show": "చూపు",
    "gui.spriteInfo.changeSize": "పరిమాణం మార్చు",
    "gui.spriteInfo.changeX": "X మార్చు",
    "gui.spriteInfo.changeY": "Y మార్చు",
    "gui.spriteInfo.direction": "దిశ",
    "gui.spriteInfo.changeDirection": "దిశ మార్చు",
    "gui.spriteInfo.isVisible": "కనిపిస్తోంది",
    "gui.deviceLibrary.chooseADevice": "పరికరం ఎంచుకోండి",
    "gui.deviceLibrary.deviceUrl": "పరికర URL నమోదు చేయండి",
    "gui.deviceLibrary.arduinoTag": "ఆర్డుయినో",
    "gui.deviceLibrary.microbitTag": "మైక్రో:బిట్",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "కిట్",
    "gui.deviceLibrary.shieldTag": "షీల్డ్",
    "gui.playButton.play": "ప్లే",
    "gui.playButton.stop": "ఆపు",
    "gui.gui.variableScopeOptionAllSprites": "అన్ని స్ప్రైట్‌ల కోసం",
    "gui.gui.variableScopeOptionSpriteOnly": "ఈ స్ప్రైట్ కోసం మాత్రమే",
    "gui.gui.cloudVariableOption": "క్లౌడ్ వేరియబుల్ (సర్వర్‌లో భద్రపరచబడింది)",
    "gui.gui.variablePromptDefaultValue": "నా వేరియబుల్",
    "gui.gui.listVariable": "జాబితా సృష్టించు",
    "gui.gui.makeAVariable": "వేరియబుల్ సృష్టించు",
    "gui.gui.newVariable": "కొత్త వేరియబుల్",
    "gui.soundEditor.sound": "ధ్వని",
    "gui.soundEditor.play": "ప్లే",
    "gui.soundEditor.stop": "ఆపు",
    "gui.soundEditor.copy": "కాపీ",
    "gui.soundEditor.paste": "అతికించు",
    "gui.soundEditor.copyToNew": "కొత్తదానిలో కాపీ",
    "gui.soundEditor.delete": "తొలగించు",
    "gui.soundEditor.save": "భద్రపరచు",
    "gui.soundEditor.undo": "అండు",
    "gui.soundEditor.redo": "రీడు",
    "gui.soundEditor.faster": "వేగంగా",
    "gui.soundEditor.slower": "నెమ్మదిగా",
    "gui.soundEditor.echo": "ఎకో",
    "gui.soundEditor.robot": "రోబోట్",
    "gui.soundEditor.louder": "బిగ్గరగా",
    "gui.soundEditor.softer": "మెత్తగా",
    "gui.soundEditor.reverse": "రివర్స్",
    "gui.soundEditor.fadeOut": "ఫేడ్ అవుట్",
    "gui.soundEditor.fadeIn": "ఫేడ్ ఇన్",
    "gui.soundEditor.mute": "మ్యూట్",
    "paint.paintEditor.hue": "రంగు",
    "paint.paintEditor.saturation": "సాచురేషన్",
    "paint.paintEditor.brightness": "ప్రకాశం",
    "paint.paintEditor.fill": "నింపు",
    "paint.paintEditor.costume": "దుస్తు",
    "paint.paintEditor.group": "గుంపు చేయి",
    "paint.paintEditor.ungroup": "గుంపు తీసివేయి",
    "paint.paintEditor.undo": "అండు",
    "paint.paintEditor.redo": "రీడు",
    "paint.paintEditor.forward": "ముందుకు తీసుకురా",
    "paint.paintEditor.backward": "వెనుకకు పంపు",
    "paint.paintEditor.front": "ముందుకు",
    "paint.paintEditor.back": "వెనుకకు",
    "paint.paintEditor.more": "మరిన్ని",
    "paint.modeTools.brushSize": "బ్రష్ పరిమాణం",
    "paint.modeTools.eraserSize": "ఎరేసర్ పరిమాణం",
    "paint.modeTools.copy": "కాపీ",
    "paint.modeTools.paste": "అతికించు",
    "paint.modeTools.delete": "తొలగించు",
    "paint.modeTools.curved": "వక్రంగా",
    "paint.modeTools.pointed": "పదునైనది",
    "paint.modeTools.thickness": "మందం",
    "paint.modeTools.flipHorizontal": "హారిజాంటల్ ఫ్లిప్",
    "paint.modeTools.flipVertical": "వర్టికల్ ఫ్లిప్",
    "paint.modeTools.filled": "నిండిన",
    "paint.modeTools.outlined": "అవుట్‌లైన్",
    "paint.paintEditor.bitmap": "బిట్‌మ్యాప్‌కు మార్చు",
    "paint.paintEditor.vector": "వెక్టర్‌కు మార్చు",
    "paint.paintEditor.stroke": "స్ట్రోక్",
    "paint.brushMode.brush": "బ్రష్",
    "paint.eraserMode.eraser": "ఎరేసర్",
    "paint.fillMode.fill": "నింపు",
    "paint.lineMode.line": "లైన్",
    "paint.ovalMode.oval": "ఓవల్",
    "paint.rectMode.rect": "దీర్ఘచతురస్రం",
    "paint.reshapeMode.reshape": "రీషేప్",
    "paint.roundedRectMode.roundedRect": "రౌండెడ్ దీర్ఘచతురస్రం",
    "paint.selectMode.select": "ఎంచుకో",
    "paint.textMode.text": "టెక్స్ట్",
    "paint.colorPicker.swap": "మార్చు",
    "gui.uploadProgress.uploading": "అప్‌లోడ్ అవుతోంది",
    "gui.uploadProgress.uploadSuccess": "అప్‌లోడ్ విజయవంతం",
    "gui.uploadProgress.uploadError": "అప్‌లోడ్ లోపం",
    "gui.uploadProgress.close": "మూసివేయి",
    "gui.uploadProgress.abort": "రద్దు చేయి",
    "gui.connection.connect": "కనెక్ట్ చేయి",
    "gui.connection.disconnect": "డిస్‌కనెక్ట్ చేయి",
    "gui.connection.connected": "కనెక్ట్ అయింది",
    "gui.connection.connecting": "కనెక్ట్ అవుతోంది...",
    "gui.connection.error": "లోపం",
    "gui.connection.unavailable": "అందుబాటులో లేదు",
    "gui.connection.noDevicesFound": "ఏ పరికరాలు దొరకలేదు",
    "gui.connection.scanning": "స్కాన్ చేస్తోంది...",
    "gui.connection.help": "సహాయం",
    "gui.connection.refresh": "రిఫ్రెష్",
    "blockly.deleteBlock": "బ్లాక్ తొలగించు",
    "blockly.duplicateBlock": "నకలు తయారు చేయి",
    "blockly.addComment": "వ్యాఖ్య జోడించు",
    "blockly.removeComment": "వ్యాఖ్య తొలగించు",
    "blockly.externalInput": "బాహ్య ఇన్‌పుట్",
    "blockly.inlineInput": "ఇన్‌లైన్ ఇన్‌పుట్",
    "blockly.disableBlock": "బ్లాక్‌ను డిసేబుల్ చేయి",
    "blockly.enableBlock": "బ్లాక్‌ను ఎనేబుల్ చేయి",
    "blockly.expandBlock": "బ్లాక్‌ను విస్తరించు",
    "blockly.collapseBlock": "బ్లాక్‌ను కుదించు",
    "blockly.help": "సహాయం",
    "blockly.undo": "అండు",
    "blockly.redo": "రీడు",
    "blockly.cleanUp": "బ్లాక్‌లను అమర్చు",
    "blockly.sortByCategory": "వర్గం ప్రకారం క్రమబద్ధీకరించు",
    "blockly.workspaceComment": "వర్క్‌స్పేస్ వ్యాఖ్య",
    "blockly.exportToHtml": "HTMLగా ఎక్స్‌పోర్ట్ చేయి",
    "blockly.snapToGrid": "గ్రిడ్‌కు అతికించు",
    "blockly.cannotDeleteVariable": "ఈ వేరియబుల్‌ను తొలగించలేము",
    "blockly.renameVariable": "వేరియబుల్ పేరు మార్చు",
    "blockly.newVariable": "కొత్త వేరియబుల్",
    "blockly.renameVariableTitle": 'అన్ని "%1" వేరియబుల్స్ పేరు మార్చు:',
    "blockly.variableAlreadyExists": '"%1" అనే పేరుతో వేరియబుల్ ఇప్పటికే ఉంది',
    // Device translations
    "gui.device.unselectDevice.name": "పరికరాన్ని ఎంచుకోవద్దు",
    "gui.device.unselectDevice.description":
        "పరికరాన్ని ఎంచుకోకుండా, స్వచ్ఛమైన రియల్-టైమ్ ప్రోగ్రామింగ్ మోడ్‌కు తిరిగి వెళ్లు.",
    "gui.device.connectingMessage": "కనెక్ట్ అవుతోంది",
    "gui.device.arduinoUno.description":
        "ఎలక్ట్రానిక్స్ మరియు కోడింగ్ ప్రారంభించడానికి ఉత్తమ బోర్డు.",
    "gui.device.arduinoNano.description":
        "మీ ప్రాజెక్టులను రూపొందించడానికి చిన్న క్లాసిక్ Arduino Nano బోర్డు.",
    "gui.device.arduinoLeonardo.description":
        "మౌస్ లేదా కీబోర్డుగా పనిచేయగల క్లాసిక్ Arduino బోర్డు.",
    "gui.device.arduinoMega2560.description":
        "54 డిజిటల్ పిన్‌లు, 16 అనలాగ్ ఇన్‌పుట్‌లు మరియు 4 సీరియల్ పోర్ట్‌లతో 8-బిట్ బోర్డు.",
    "gui.device.arduinoUnoR4Minima.description":
        "మెరుగైన పనితీరు మరియు మెమరీ, ఉన్న షీల్డ్‌లు మరియు ఆప్షన్‌లతో అనుకూలం.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi మరియు Bluetooth కనెక్టివిటీ, ఆన్-బోర్డ్ 12x8 LED మ్యాట్రిక్స్.",
    "gui.device.esp32.description":
        "Wi-Fi మరియు Bluetoothతో బహుళ ఫంక్షనల్ కంట్రోలర్ బోర్డు.",
    "gui.device.esp32S3.description":
        "AI యాక్సిలరేటర్ మరియు బహుళ పెరిఫెరల్స్‌తో IoT మరియు AI టాస్క్‌ల కోసం.",
    "gui.device.esp8266NodeMCU.description":
        "తక్కువ ధర Wi-Fi SOC కంట్రోలర్ బోర్డు.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V చిప్ ఆధారంగా అన్ని IO పిన్‌లు బయటపడిన బేసిక్ బోర్డు.",
    "gui.device.k210Maixduino.description":
        "ESP32తో కలిపిన K210 RISC-V బోర్డు.",
    "gui.device.raspberryPiPicoIconURL.description":
        "మీ ఎలక్ట్రానిక్స్ ఆలోచనలను జీవంలోకి తెచ్చే సులభమైన మైక్రోకంట్రోలర్ బోర్డు.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "బిల్ట్-ఇన్ Wi-Fi మరియు Bluetooth 5.2తో వైర్‌లెస్ మరియు IoT ప్రాజెక్టులకు అనువైనది.",
    "gui.device.raspberryPiPico2IconURL.description":
        "పెద్ద RAM మరియు ఫ్లాష్‌తో హై-పెర్ఫార్మెన్స్ డ్యూయల్-కోర్ MCU.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "బిల్ట్-ఇన్ 2.4 GHz Wi-Fi మరియు Bluetoothతో వైర్‌లెస్ IoT మరియు స్మార్ట్-హోమ్ ఇంటిగ్రేషన్ కోసం.",
    "gui.device.microbit.description":
        "జేబు సైజు కంప్యూటర్ డిజిటల్ నైపుణ్యాలను మార్చివేస్తుంది.",
    "gui.device.microbitV2.description":
        "మెరుగైన ప్రాసెసర్, బిల్ట్-ఇన్ స్పీకర్ మరియు మైక్రోఫోన్, టచ్ సెన్సిటివ్ లోగో.",
    "gui.device.makeymakey.description": "ఏదైనా కీగా మార్చండి.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT అనేది Wi-Fi, Bluetooth మరియు రోబోటిక్స్, IoT ప్రాజెక్టుల కోసం సమృద్ధ పెరిఫెరల్స్‌తో కూడిన ESP32-S3 ఆధారిత బోర్డు.",
    "gui.device.lightWingDrone.description":
        "లైట్ వింగ్ డ్రోన్ అనేది అధునాతన స్టెబిలైజేషన్ మరియు Wi-Fi నియంత్రణతో కూడిన హై-పెర్ఫార్మెన్స్ ESP32-S3 ఆధారిత ఫ్లైట్ కంట్రోలర్.",
    "gui.device.roboticDog.description":
        "Robotic Dog అనేది Arduino Nano ద్వారా నడపబడే ఒక స్మార్ట్ నాలుగు కాళ్ల రోబోట్, ఇది జీవంతో కూడిన కదలికలు మరియు అడ్డంకులను నివారించగల సామర్థ్యం కలిగి ఉంది.",
    "gui.device.roboticArm.description":
        "Robotic Arm అనేది Arduino Nano ద్వారా నడపబడే బహుళ-అక్ష మానిప్యులేటర్, ఇది ఖచ్చితమైన పనులు మరియు ఆటోమేషన్ నేర్చుకోవడానికి రూపొందించబడింది.",
    // Extension Library Names and Descriptions
    "gui.extension.music.name": "సంగీతం",
    "gui.extension.music.description": "వాయిద్యాలు మరియు డ్రమ్స్ వాయించండి.",
    "gui.extension.pen.name": "పెన్",
    "gui.extension.pen.description": "మీ స్ప్రైట్‌లతో గీయండి.",
    "gui.extension.videosensing.name": "వీడియో సెన్సింగ్",
    "gui.extension.videosensing.description":
        "కెమెరా ద్వారా కదలికను గుర్తించండి.",
    "gui.extension.poseface.name": "ఫేస్ సెన్సింగ్",
    "gui.extension.poseface.description":
        "కెమెరా ద్వారా ముఖ కదలికలను గుర్తించండి.",
    "gui.extension.posehand.name": "హ్యాండ్ సెన్సింగ్",
    "gui.extension.posehand.description":
        "కెమెరా ద్వారా చేతి కదలికలను గుర్తించండి.",
    "gui.extension.posebody.name": "బాడీ పోజ్ సెన్సింగ్",
    "gui.extension.posebody.description":
        "కెమెరా ద్వారా శరీర కదలికలను గుర్తించండి.",
    "gui.extension.teachablemachine.name": "టీచబుల్ మెషిన్",
    "gui.extension.teachablemachine.description":
        "మీ కెమెరాతో కస్టమ్ మెషిన్ లెర్నింగ్ మోడళ్లను ఉపయోగించండి.",
    "gui.extension.text2speech.name": "టెక్స్ట్ టు స్పీచ్",
    "gui.extension.text2speech.description": "మీ ప్రాజెక్టులతో మాట్లాడించండి.",
    "gui.extension.translate.name": "అనువాదం",
    "gui.extension.translate.description":
        "వచనాన్ని అనేక భాషల్లోకి అనువదించండి.",
    "gui.extension.makeymakey.name": "మేకీ మేకీ",
    "gui.extension.makeymakey.description": "దేనినైనా ఒక కీగా (Key) మార్చండి.",

    // Arduino Translations
    "arduinoUno.category.pins": "పిన్స్",
    "arduinoUno.category.serial": "సీరియల్",
    "arduinoUno.category.data": "డేటా",

    "arduinoNano.category.pins": "పిన్స్",
    "arduinoNano.category.serial": "సీరియల్",
    "arduinoNano.category.data": "డేటా",

    "arduinoLeonardo.category.pins": "పిన్స్",
    "arduinoLeonardo.category.serial": "సీరియల్",
    "arduinoLeonardo.category.data": "డేటా",

    "arduinoMega2560.category.pins": "పిన్స్",
    "arduinoMega2560.category.serial": "సీరియల్",
    "arduinoMega2560.category.data": "డేటా",

    "arduinoEsp32.category.pins": "పిన్స్",
    "arduinoEsp32.category.serial": "సీరియల్",
    "arduinoEsp32.category.data": "డేటా",

    "arduinoEsp8266.category.pins": "పిన్స్",
    "arduinoEsp8266.category.serial": "సీరియల్",
    "arduinoEsp8266.category.data": "డేటా",

    "arduinoK210.category.pins": "పిన్స్",
    "arduinoK210.category.serial": "సీరియల్",
    "arduinoK210.category.data": "డేటా",

    "arduinoRaspberryPiPico.category.pins": "పిన్స్",
    "arduinoRaspberryPiPico.category.serial": "సీరియల్",
    "arduinoRaspberryPiPico.category.data": "డేటా",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ఇన్‌పుట్",
    "arduinoUno.modeMenu.output": "అవుట్‌పుట్",
    "arduinoUno.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoUno.levelMenu.high": "హై (High)",
    "arduinoUno.levelMenu.low": "లో (Low)",
    "arduinoUno.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoUno.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoUno.pins.setPwmOutput": "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoUno.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoUno.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoUno.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoUno.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoUno.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoUno.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoUno.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoUno.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoUno.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ఇన్‌పుట్",
    "arduinoNano.modeMenu.output": "అవుట్‌పుట్",
    "arduinoNano.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoNano.levelMenu.high": "హై (High)",
    "arduinoNano.levelMenu.low": "లో (Low)",
    "arduinoNano.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoNano.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoNano.pins.setPwmOutput": "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoNano.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoNano.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoNano.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoNano.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoNano.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoNano.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoNano.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoNano.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoNano.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ఇన్‌పుట్",
    "arduinoLeonardo.modeMenu.output": "అవుట్‌పుట్",
    "arduinoLeonardo.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoLeonardo.levelMenu.high": "హై (High)",
    "arduinoLeonardo.levelMenu.low": "లో (Low)",
    "arduinoLeonardo.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoLeonardo.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoLeonardo.pins.setPwmOutput":
        "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoLeonardo.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoLeonardo.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoLeonardo.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoLeonardo.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoLeonardo.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoLeonardo.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoLeonardo.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoLeonardo.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ఇన్‌పుట్",
    "arduinoMega2560.modeMenu.output": "అవుట్‌పుట్",
    "arduinoMega2560.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoMega2560.levelMenu.high": "హై (High)",
    "arduinoMega2560.levelMenu.low": "లో (Low)",
    "arduinoMega2560.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoMega2560.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoMega2560.pins.setPwmOutput":
        "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoMega2560.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoMega2560.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoMega2560.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoMega2560.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoMega2560.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoMega2560.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoMega2560.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoMega2560.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoMega2560.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ఇన్‌పుట్",
    "arduinoEsp32.modeMenu.output": "అవుట్‌పుట్",
    "arduinoEsp32.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoEsp32.levelMenu.high": "హై (High)",
    "arduinoEsp32.levelMenu.low": "లో (Low)",
    "arduinoEsp32.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoEsp32.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoEsp32.pins.setPwmOutput": "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoEsp32.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoEsp32.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoEsp32.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoEsp32.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoEsp32.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoEsp32.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoEsp32.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoEsp32.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoEsp32.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ఇన్‌పుట్",
    "arduinoEsp8266.modeMenu.output": "అవుట్‌పుట్",
    "arduinoEsp8266.modeMenu.inputPullup": "ఇన్‌పుట్-పుల్‌అప్",
    "arduinoEsp8266.levelMenu.high": "హై (High)",
    "arduinoEsp8266.levelMenu.low": "లో (Low)",
    "arduinoEsp8266.pins.setPinMode": "పిన్ [PIN] మోడ్ [MODE] సెట్ చేయండి",
    "arduinoEsp8266.pins.setDigitalOutput":
        "డిజిటల్ పిన్ [PIN] అవుట్ [LEVEL] సెట్ చేయండి",
    "arduinoEsp8266.pins.setPwmOutput":
        "PWM పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoEsp8266.pins.readDigitalPin": "డిజిటల్ పిన్ [PIN] చదవండి",
    "arduinoEsp8266.pins.readAnalogPin": "అనలాగ్ పిన్ [PIN] చదవండి",
    "arduinoEsp8266.pins.setServoOutput":
        "సర్వో పిన్ [PIN] అవుట్ [OUT] సెట్ చేయండి",
    "arduinoEsp8266.pins.attachInterrupt":
        "ఇంటరప్ట్ పిన్ [PIN] మోడ్ [MODE] అటాచ్ చేయండి",
    "arduinoEsp8266.pins.detachInterrupt": "ఇంటరప్ట్ పిన్ [PIN] డిటాచ్ చేయండి",
    "arduinoEsp8266.serial.serialBegin": "సీరియల్ ప్రారంభ బాడ్‌రేట్ [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "సీరియల్ ప్రింట్ [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "సీరియల్ అందుబాటు డేటా పొడవు",
    "arduinoEsp8266.serial.serialReadAByte": "సీరియల్ ఒక బైట్ చదవండి",
    "arduinoEsp8266.data.dataMap":
        "[DATA] ను ([ARG0], [ARG1]) నుండి ([ARG2], [ARG3]) కు మ్యాప్ చేయండి",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoUno.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoUno.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoUno.dataTypeMenu.decimal": "దశాంశం",
    "arduinoUno.dataTypeMenu.string": "స్ట్రింగ్",

    "arduinoNano.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoNano.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoNano.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoNano.dataTypeMenu.decimal": "దశాంశం",
    "arduinoNano.dataTypeMenu.string": "స్ట్రింగ్",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoLeonardo.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoLeonardo.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoLeonardo.dataTypeMenu.decimal": "దశాంశం",
    "arduinoLeonardo.dataTypeMenu.string": "స్ట్రింగ్",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoMega2560.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoMega2560.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoMega2560.dataTypeMenu.decimal": "దశాంశం",
    "arduinoMega2560.dataTypeMenu.string": "స్ట్రింగ్",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoEsp32.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoEsp32.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoEsp32.dataTypeMenu.decimal": "దశాంశం",
    "arduinoEsp32.dataTypeMenu.string": "స్ట్రింగ్",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] ను ([ARG0], [ARG1]) మధ్య పరిమితం చేయండి",
    "arduinoEsp8266.data.dataConvert": "[DATA] ను [TYPE] కు మార్చండి",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] ను ASCII అక్షరానికి మార్చండి",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] ను ASCII సంఖ్యకు మార్చండి",
    "arduinoEsp8266.dataTypeMenu.integer": "పూర్ణాంకం",
    "arduinoEsp8266.dataTypeMenu.decimal": "దశాంశం",
    "arduinoEsp8266.dataTypeMenu.string": "స్ట్రింగ్",
    // Library manager & Board manager
    "gui.librariesBoardsTab": "లైబ్రరీలు",
    "gui.boardManagerTab": "బోర్డ్ మేనేజర్",

    "gui.boardManager.title": "బోర్డ్ మేనేజర్",
    "gui.boardManager.description":
        "అధికారిక Arduino బోర్డులను వెతికి ఇన్‌స్టాల్ చేయండి.",
    "gui.boardManager.searchPlaceholder": "Arduino బోర్డ్ వెతకండి (ఉదా: esp32)",
    "gui.boardManager.search": "వెతకండి",
    "gui.boardManager.searching": "వెతుకుతోంది...",
    "gui.boardManager.advancedOptionsShow":
        "▶ అధునాతన ఎంపికలు (కస్టమ్ ఇన్‌స్టాల్ పాత్)",
    "gui.boardManager.advancedOptionsHide": "▼ అధునాతన ఎంపికలను దాచు",
    "gui.boardManager.recommended": "సిఫార్సు చేయబడిన",
    "gui.boardManager.installed": "ఇన్‌స్టాల్ చేయబడింది ({count})",
    "gui.boardManager.searchResults": "శోధన ఫలితాలు {count}",
    "gui.boardManager.refresh": "↻ రీఫ్రెష్",
    "gui.boardManager.refreshing": "↻ రీఫ్రెష్ అవుతోంది...",

    "gui.libraryManager.title": "లైబ్రరీ మేనేజర్",
    "gui.libraryManager.description":
        "అధికారిక Arduino లైబ్రరీలను వెతికి ఇన్‌స్టాల్ చేయండి.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino లైబ్రరీ వెతకండి (ఉదా: Servo)",
    "gui.libraryManager.search": "వెతకండి",
    "gui.libraryManager.searching": "వెతుకుతోంది...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ అధునాతన ఎంపికలు (కస్టమ్ ఇన్‌స్టాల్ పాత్)",
    "gui.libraryManager.advancedOptionsHide": "▼ అధునాతన ఎంపికలను దాచు",
    "gui.libraryManager.recommended": "సిఫార్సు చేయబడిన",
    "gui.libraryManager.installed": "ఇన్‌స్టాల్ చేయబడింది ({count})",
    "gui.libraryManager.searchResults": "శోధన ఫలితాలు {count}",
    "gui.libraryManager.refresh": "↻ రీఫ్రెష్",
    "gui.libraryManager.refreshing": "↻ రీఫ్రెష్ అవుతోంది...",
    "gui.gui.librariesBoardsTab": "లైబ్రరీలు",
    "gui.gui.boardsManagerTab": "బోర్డ్ మేనేజర్",
};

export default te;
